import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Switch,
  FormControl,
  IconButton,
  Card,
  CardContent,
  FormGroup,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "@mui/material/Grid2";
import routes from "../../../routes";
import { postItem, updateItem } from "../../../BaseUrl";
import { CREATEROLE, UPDATEROLE } from "./Mutation";

const AddRole = ({
  formClose,
  oneRoleData,
  setPopup,
  isView,
  setDialogData,
  handleOpenDialog,
}) => {
  const [roleData, setRoleData] = useState({
    roleName: "",
    roleNameStatus: "unchecked",
  });
  const [isActive, setIsActive] = useState(true);

  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (oneRoleData.length > 0) {
      setRoleData({
        roleName: oneRoleData[0].roleName || "",
        roleNameStatus: "success",
      });
      setIsActive(oneRoleData[0].status || false);
      setPermissions(oneRoleData[0].permission || []);
    } else {
      setRoleData({
        roleName: "",
        roleNameStatus: "unchecked",
      });
      setIsActive(true);
      setPermissions([]);
    }
  }, [oneRoleData]);

  const handleCheckboxChange = (type, name, parent, isChecked) => {
    setPermissions((prev) => {
      let updated = [...prev];

      if (type === "name") {
        const index = updated.findIndex((item) => item.name === name);

        if (isChecked) {
          if (index === -1) {
            updated.push({ name, access: [] });
          }
        } else {
          if (index !== -1) {
            updated.splice(index, 1);
          }
        }
      }

      if (type === "action" && parent) {
        const index = updated.findIndex((item) => item.name === parent);

        if (index === -1 && isChecked) {
          updated.push({ name: parent, access: [name] });
        } else if (index !== -1) {
          const accessSet = new Set(updated[index].access);

          if (isChecked) {
            accessSet.add(name);
          } else {
            accessSet.delete(name);
          }

          const newAccess = Array.from(accessSet);

          if (newAccess.length === 0) {
            updated.splice(index, 1);
          } else {
            updated[index] = { name: parent, access: newAccess };
          }
        }
      }

      return updated;
    });
  };

  const handleSelectAllRoute = (route, isChecked) => {
    setPermissions((prev) => {
      let updated = [...prev];

      if (isChecked) {
        // Add route and all sub-routes/actions to permissions
        if (!route.collapse) {
          const index = updated.findIndex((item) => item.name === route.name);
          if (index === -1) {
            updated.push({ name: route.name, access: route.action || [] });
          }
        } else {
          route.collapse.forEach((subRoute) => {
            const index = updated.findIndex(
              (item) => item.name === subRoute.name
            );
            if (index === -1) {
              updated.push({
                name: subRoute.name,
                access: subRoute.action || [],
              });
            }
          });
        }
      } else {
        // Remove route and all sub-routes/actions from permissions
        if (!route.collapse) {
          updated = updated.filter((item) => item.name !== route.name);
        } else {
          route.collapse.forEach((subRoute) => {
            updated = updated.filter((item) => item.name !== subRoute.name);
          });
        }
      }

      return updated;
    });
  };

  // const handleCheckboxChange = (type, name, parent, isChecked) => {
  //   setPermissions((prev) => {
  //     let updated = [...prev];

  //     if (type === "name") {
  //       const index = updated.findIndex((item) => item.name === name);

  //       if (isChecked) {
  //         if (index === -1) {
  //           updated.push({ name, access: [] });
  //         }
  //       } else {
  //         if (index !== -1) {
  //           updated.splice(index, 1);
  //         }
  //       }
  //     }

  //     if (type === "action" && parent) {
  //       const index = updated.findIndex((item) => item.name === parent);

  //       if (index === -1 && isChecked) {
  //         // Add parent with this action
  //         updated.push({ name: parent, access: [name] });
  //       } else if (index !== -1) {
  //         const accessSet = new Set(updated[index].access);

  //         if (isChecked) {
  //           accessSet.add(name);
  //         } else {
  //           accessSet.delete(name);
  //         }

  //         const newAccess = Array.from(accessSet);

  //         if (newAccess.length === 0) {
  //           // Remove route if no access left
  //           updated.splice(index, 1);
  //         } else {
  //           updated[index] = { name: parent, access: newAccess };
  //         }
  //       }
  //     }

  //     return updated;
  //   });
  // };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...roleData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "regulation") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "roleName":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,20}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setRoleData(formState);
  };
  const isButtonDisabled = () => {
    return roleData.roleNameStatus === "unchecked" || permissions.length === 0;
  };
  //reset form
  const resetForm = () => {
    setPermissions([]);
    setIsActive(true);
    setRoleData({
      roleName: "",
      roleNameStatus: "unchecked",
    });
    formClose();
  };
  const onSubmitOpen = () => {
    handleOpenDialog();
    setDialogData({
      title: `${oneRoleData.length > 0 ? "Update" : "Create"} role ?`,
      content: `Are you sure you want to ${
        oneRoleData.length > 0 ? "update" : "Create"
      } role ?`,
      onConfirm: () => handleSubmit(),
    });
  };
  //submit form
  const handleSubmit = async (e) => {
    const variables = {
      roleName: roleData.roleName,
      permissions: permissions,
      status: isActive,
    };
    try {
      //update api call
      if (oneRoleData.length > 0) {
        variables.id = oneRoleData[0].id;
        const response = await updateItem(UPDATEROLE, {
          input: variables,
        });
        if (response?.updateRole?.success === true) {
          setPopup({
            open: true,
            message: response?.updateRole?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.updateRole?.message,
            severity: "error",
          });
        }
      } else {
        //Post api call
        const response = await postItem(CREATEROLE, { input: variables });
        if (response?.createRole?.success === true) {
          setPopup({
            open: true,
            message: response?.createRole?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.createRole?.message,
            severity: "error",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
      resetForm();
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 4 }}>
          <IconButton onClick={formClose}>
            <ArrowBackIcon sx={{ color: "#000" }} />
          </IconButton>{" "}
          <MaterialTypography
            sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
            mb={2}
          >
            {oneRoleData.length > 0 ? "Update" : "New"} Role
          </MaterialTypography>
        </Box>
        <IconButton onClick={formClose}>
          <ClearIcon sx={{ color: "#000" }} />
        </IconButton>
      </Box>

      <form>
        <FormControl fullWidth>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Role Name:
          </MaterialTypography>
          <MaterialInput
            fullWidth
            name="roleName"
            variant="standard"
            value={roleData.roleName}
            onChange={handleAddCourseChange}
            error={roleData.roleNameStatus === "error" ? true : false}
            success={roleData.roleNameStatus === "success" ? true : false}
            disabled={isView}
          />
        </FormControl>

        <MaterialTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          sx={{ color: "black" }}
          mt={2}
          mb={1}
        >
          Permissions
        </MaterialTypography>
        <Grid container spacing={1}>
          {/* Top-Level Routes Without Collapse */}
          {routes
            .filter(
              (route) =>
                route.name !== "Authentication" &&
                route.roleAcess === true &&
                (!route.collapse || route.collapse.length === 0)
            )
            .map((route, index) => (
              <Grid size={{ xs: 6, md: 6, sm: 6 }} key={index}>
                <Card key={index} variant="outlined">
                  <CardContent>
                    <MaterialTypography
                      sx={{
                        color: "#000",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                      gutterBottom
                    >
                      {route.name || "Unnamed Section"}
                    </MaterialTypography>
                    <FormGroup>
                      {/* Select All Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={permissions.some(
                              (p) =>
                                p.name === route.name &&
                                p.access.length === (route.action?.length || 0)
                            )}
                            indeterminate={
                              permissions.some(
                                (p) =>
                                  p.name === route.name && p.access.length > 0
                              ) &&
                              !permissions.some(
                                (p) =>
                                  p.name === route.name &&
                                  p.access.length ===
                                    (route.action?.length || 0)
                              )
                            }
                            onChange={(e) =>
                              handleSelectAllRoute(route, e.target.checked)
                            }
                          />
                        }
                        disabled={isView}
                        label={`Select All`}
                      />
                      {/* Route Name Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={permissions.some(
                              (p) => p.name === route.name
                            )}
                            onChange={(e) =>
                              handleCheckboxChange(
                                "name",
                                route.name,
                                null,
                                e.target.checked
                              )
                            }
                          />
                        }
                        disabled={isView}
                        label={`Access ${route.name}`}
                      />
                    </FormGroup>

                    {/* Route Actions */}
                    {route.action && (
                      <FormGroup>
                        {route.action.map((action, actionIndex) => (
                          <FormControlLabel
                            key={actionIndex}
                            control={
                              <Checkbox
                                checked={
                                  permissions
                                    .find((p) => p.name === route.name)
                                    ?.access.includes(action) || false
                                }
                                disabled={
                                  !permissions.some(
                                    (p) => p.name === route.name
                                  ) || isView
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    "action",
                                    action,
                                    route.name,
                                    e.target.checked
                                  )
                                }
                              />
                            }
                            label={action}
                          />
                        ))}
                      </FormGroup>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

          {/* Routes with Collapse */}
          {routes
            .filter(
              (route) =>
                route.name !== "Authentication" &&
                route.roleAcess === true &&
                route.collapse
            )
            .map((route, routeIndex) =>
              route.collapse.map((subRoute, subIndex) => (
                <Grid
                  size={{ xs: 6, md: 6, sm: 6 }}
                  key={`${route.key}-${subIndex}`}
                >
                  <Card key={`${route.key}-${subIndex}`} variant="outlined">
                    <CardContent>
                      <MaterialTypography
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                        gutterBottom
                      >
                        {subRoute.name || "Unnamed Section"}
                      </MaterialTypography>

                      <FormGroup>
                        {/* Select All Checkbox */}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={permissions.some(
                                (p) =>
                                  p.name === subRoute.name &&
                                  p.access.length ===
                                    (subRoute.action?.length || 0)
                              )}
                              indeterminate={
                                permissions.some(
                                  (p) =>
                                    p.name === subRoute.name &&
                                    p.access.length > 0
                                ) &&
                                !permissions.some(
                                  (p) =>
                                    p.name === subRoute.name &&
                                    p.access.length ===
                                      (subRoute.action?.length || 0)
                                )
                              }
                              onChange={(e) =>
                                handleSelectAllRoute(subRoute, e.target.checked)
                              }
                            />
                          }
                          disabled={isView}
                          label={`Select All`}
                        />
                        {/* Sub-route Name Checkbox */}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={permissions.some(
                                (p) => p.name === subRoute.name
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  "name",
                                  subRoute.name,
                                  null,
                                  e.target.checked
                                )
                              }
                            />
                          }
                          disabled={isView}
                          label={`${subRoute.name}`}
                        />
                      </FormGroup>

                      {/* Sub-route Actions */}
                      {subRoute.action && (
                        <FormGroup>
                          {subRoute.action.map((action, actionIndex) => (
                            <FormControlLabel
                              key={actionIndex}
                              control={
                                <Checkbox
                                  checked={
                                    permissions
                                      .find((p) => p.name === subRoute.name)
                                      ?.access.includes(action) || false
                                  }
                                  disabled={
                                    !permissions.some(
                                      (p) => p.name === subRoute.name
                                    ) || isView
                                  }
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      "action",
                                      action,
                                      subRoute.name,
                                      e.target.checked
                                    )
                                  }
                                />
                              }
                              label={action}
                            />
                          ))}
                        </FormGroup>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
        </Grid>

        <Box mt={2} pl={3}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Status:
          </MaterialTypography>
          <FormControlLabel
            control={
              <Switch
                checked={isActive}
                onChange={() => setIsActive(!isActive)}
              />
            }
            label={isActive ? "Active" : "Inactive"}
          />
        </Box>

        {!isView && (
          <Box display="flex" justifyContent="space-around" mt={3}>
            <MaterialButton
              variant="contained"
              sx={{
                background: colors.buttonColor,
                color: "#fff",
                textTransform: "capitalize",
              }}
              disabled={isButtonDisabled()}
              onClick={onSubmitOpen}
            >
              {oneRoleData.length > 0 ? "Update" : "Submit"}
            </MaterialButton>
            <MaterialButton
              onClick={formClose}
              variant="outlined"
              color="error"
            >
              Cancel
            </MaterialButton>
          </Box>
        )}
      </form>
    </Box>
  );
};

export default AddRole;
